<template>
  <div class="d-flex justify-content-center mb-5">
    <b-container>
      <b-row>
        <b-col v-if="!loaded && !showError" class="col-12 col-md-12 mb-3">
          <b-card>
            <div class="d-flex justify-content-center mb-3 mt-3">
              <b-spinner></b-spinner>
            </div>
          </b-card>
        </b-col>
        <b-col v-if="showError" class="col-12 col-md-12 mb-3">
          <b-card>
            <p class="text-center">{{ $t('measures.error') }}</p>
          </b-card>
        </b-col>
      </b-row>
<!--      <div v-for="(measures, date) in data" :key="date" class="w-100 measure-container">-->
<!--        <div @click="toggleCollapse(date)" class="measure-date text-center text-light p-2">{{ formatDate(date) }}</div>-->
<!--        <b-collapse :id="'measures-' + date" accordion="measures">-->
<!--          <b-card>-->
<!--            <div class="mb-3" v-for="(measure, i) in measures" :key="i">-->
<!--              <div class="d-flex justify-content-between">-->
<!--                <h3 class="text-body text-center w-100">-->
<!--                  {{ $t('measure.types.' + measure.type) }}-->
<!--                </h3>-->
<!--                <b-link class="text-body icon-pen text-decoration-none" @click="checkNetworkUpdateMeasure(measure.id)" :title="$t('measure_edit.title')" ></b-link>-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_varroa_diagnose' && measure.diagnosis">-->
<!--                {{ $t('measure.form.diagnosis.options.' + measure.diagnosis) }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_varroa_diagnose' && measure.mites">-->
<!--                {{ $t('measure.form.mites.label') + ': ' + measure.mites }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_varroa_diagnose' && measure.diagnosis === 'bed' && measure.days">-->
<!--                {{ $t('measure.form.days.label') + ': ' + measure.days }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_varroa_diagnose' && measure.diagnosis === 'washout' && measure.bee_mass">-->
<!--                {{ $t('measure.form.bee_mass.label') + ': ' + measure.bee_mass }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_varroa_diagnose' && measure.diagnosis === 'bed' && (parseFloat(measure.days) > 0) && measure.mites">-->
<!--                {{ $t('measure.form.mites_day_percentage.info_msg', { percent: parseFloat((measure.mites / measure.days * 10).toFixed(1)) }) }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_varroa_diagnose' && measure.diagnosis === 'washout' && (parseFloat(measure.mites) > 0) && measure.bee_mass">-->
<!--                {{ $t('measure.form.mites_bee_mass_percentage.info_msg', { percent: parseFloat((measure.mites / measure.bee_mass * 10).toFixed(1)) }) }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_varroa_medikamente' && measure.medicine && measure.medicine !== 'other'">-->
<!--                {{ $t('measure.form.medicine.options.' + measure.medicine) + ': ' +  measure.amount + ' '+  $t('measure.form.units.ml') }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_varroa_medikamente' && measure.medicine === 'other'">-->
<!--                {{ measure.other_medicine + ': ' +  measure.amount }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_varroa_medikamente' && measure.type === 'massnahme_futtergabe' && measure.type === 'massnahme_honigernte' && measure.amount">-->
<!--                {{ $t('measure.form.amount.label') + ': ' + measure.amount }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_varroa_biotechnik' && measure.biotech && measure.biotech !== 'other'">-->
<!--                {{ $t('measure.form.biotech.label')+ ': ' + $t('measure.form.biotech.options.' + measure.biotech) }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_varroa_biotechnik' && measure.biotech === 'other'">-->
<!--                {{ $t('measure.form.biotech.options.' + measure.biotech) }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_varroa_biotechnik' && measure.biotech === 'other'">-->
<!--                {{ $t('measure.form.biotech.label')+ ': '+ measure.other_biotech }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_schwarmverhinderung' && measure.swarm_prevention && measure.swarm_prevention !== 'other'">-->
<!--                {{ $t('measure.form.swarm_prevention.label') + ': ' + $t('measure.form.swarm_prevention.options.' + measure.swarm_prevention) }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_schwarmverhinderung' && measure.swarm_prevention === 'other'">-->
<!--                {{ $t('measure.form.swarm_prevention.options.' + measure.swarm_prevention) }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_schwarmverhinderung' && measure.swarm_prevention === 'other'">-->
<!--                {{ $t('measure.form.swarm_prevention.label') + ': ' + measure.other_swarm_prevention }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_futtergabe' && measure.feed && measure.feed !== 'other'">-->
<!--                {{ $t('measure.form.feed.label') + ': ' + $t('measure.form.feed.options.' + measure.feed) }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_futtergabe' && measure.feed && (measure.feed === 'honeycomb' || measure.feed === 'honey' || measure.feed === 'feedbee' || measure.feed === 'feedsyrup')">-->
<!--                {{ $t('measure.form.feed.amount') + ': ' + measure.amount + ' ' + $t('measure.form.units.kg')}}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_futtergabe' && measure.feed && (measure.feed === 'sugarsolution_1_1' || measure.feed === 'sugarsolution_3_2')">-->
<!--                {{ $t('measure.form.feed.amount') + ': ' + measure.amount + ' ' + $t('measure.form.units.l')}}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_futtergabe' && measure.feed === 'other'">-->
<!--                {{ $t('measure.form.feed.options.' + measure.feed) }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_futtergabe' && measure.feed === 'other'">-->
<!--                {{ $t('measure.form.feed.label') + ': ' + measure.other_feed }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_futtergabe' && measure.feed === 'other'">-->
<!--                {{ $t('measure.form.feed.amount') + ': ' + measure.amount }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_honigernte' && measure.honey_type">-->
<!--                {{ $t('measure.form.honey_type.amount') + ': ' + measure.amount + ' ' +$t('measure.form.units.kg') }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_honigernte' && measure.honey_type">-->
<!--                {{ $t('measure.form.honey_type.label') + ': ' + measure.honey_type }}-->
<!--              </div>-->
<!--              <div class="text-center" v-if="measure.type === 'massnahme_raummanagement' && measure.space_management">-->
<!--                {{ $t('measure.form.space_management.label') + ': ' + $t('measure.form.space_management.options.' + measure.space_management) }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </b-card>-->
<!--        </b-collapse>-->
<!--      </div>-->
      <div class="d-flex flex-wrap">
        <b-col class="mb-3 col-md-6 col-sm-12 col-12 col-lg-3" v-for="(measures, date) in data" :key="date" >
          <b-card
            border-variant="Dark"
            :header="formatDate(date)"
            header-bg-variant="transparent"
            align="center"
            class="h-100"
          >
            <b-card-body>
              <div class="mb-3" v-for="(measure, i) in measures" :key="i">
                <div class="d-flex justify-content-between">
                  <h3 class="text-body text-center w-100">
                    {{ $t('measure.types.' + measure.type) }}
                  </h3>
                  <b-link class="text-body icon-pen text-decoration-none edit-button" @click="checkNetworkUpdateMeasure(measure.id)" :title="$t('measure_edit.title')" ></b-link>
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_varroa_diagnose' && measure.diagnosis">
                  {{ $t('measure.form.diagnosis.options.' + measure.diagnosis) }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_varroa_diagnose' && measure.mites">
                  {{ $t('measure.form.mites.label') + ': ' + measure.mites }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_varroa_diagnose' && measure.diagnosis === 'bed' && measure.days">
                  {{ $t('measure.form.days.label') + ': ' + measure.days }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_varroa_diagnose' && measure.diagnosis === 'washout' && measure.bee_mass">
                  {{ $t('measure.form.bee_mass.label') + ': ' + measure.bee_mass }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_varroa_diagnose' && measure.diagnosis === 'bed' && (parseFloat(measure.days) > 0) && measure.mites">
                  {{ $t('measure.form.mites_day_percentage.info_msg', { percent: parseFloat((measure.mites / measure.days).toFixed(1)) }) }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_varroa_diagnose' && measure.diagnosis === 'washout' && (parseFloat(measure.mites) > 0) && measure.bee_mass">
                  {{ $t('measure.form.mites_bee_mass_percentage.info_msg', { percent: parseFloat((measure.mites / measure.bee_mass * 10).toFixed(1)) }) }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_varroa_medikamente' && measure.medicine && measure.medicine !== 'other'">
                  {{ $t('measure.form.medicine.options.' + measure.medicine) + ': ' +  measure.amount + ' '+  $t('measure.form.units.ml') }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_varroa_medikamente' && measure.medicine === 'other'">
                  {{ measure.other_medicine + ': ' +  measure.amount }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_varroa_medikamente' && measure.type === 'massnahme_futtergabe' && measure.type === 'massnahme_honigernte' && measure.amount">
                  {{ $t('measure.form.amount.label') + ': ' + measure.amount }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_varroa_biotechnik' && measure.biotech && measure.biotech !== 'other'">
                  {{ $t('measure.form.biotech.label')+ ': ' + $t('measure.form.biotech.options.' + measure.biotech) }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_varroa_biotechnik' && measure.biotech === 'other'">
                  {{ $t('measure.form.biotech.options.' + measure.biotech) }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_varroa_biotechnik' && measure.biotech === 'other'">
                  {{ $t('measure.form.biotech.label')+ ': '+ measure.other_biotech }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_schwarmverhinderung' && measure.swarm_prevention && measure.swarm_prevention !== 'other'">
                  {{ $t('measure.form.swarm_prevention.label') + ': ' + $t('measure.form.swarm_prevention.options.' + measure.swarm_prevention) }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_schwarmverhinderung' && measure.swarm_prevention === 'other'">
                  {{ $t('measure.form.swarm_prevention.options.' + measure.swarm_prevention) }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_schwarmverhinderung' && measure.swarm_prevention === 'other'">
                  {{ $t('measure.form.swarm_prevention.label') + ': ' + measure.other_swarm_prevention }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_futtergabe' && measure.feed && measure.feed !== 'other'">
                  {{ $t('measure.form.feed.label') + ': ' + $t('measure.form.feed.options.' + measure.feed) }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_futtergabe' && measure.feed && (measure.feed === 'honeycomb' || measure.feed === 'honey' || measure.feed === 'feedbee' || measure.feed === 'feedsyrup')">
                  {{ $t('measure.form.feed.amount') + ': ' + measure.amount + ' ' + $t('measure.form.units.kg')}}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_futtergabe' && measure.feed && (measure.feed === 'sugarsolution_1_1' || measure.feed === 'sugarsolution_3_2')">
                  {{ $t('measure.form.feed.amount') + ': ' + measure.amount + ' ' + $t('measure.form.units.l')}}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_futtergabe' && measure.feed === 'other'">
                  {{ $t('measure.form.feed.options.' + measure.feed) }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_futtergabe' && measure.feed === 'other'">
                  {{ $t('measure.form.feed.label') + ': ' + measure.other_feed }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_futtergabe' && measure.feed === 'other'">
                  {{ $t('measure.form.feed.amount') + ': ' + measure.amount }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_honigernte' && measure.honey_type">
                  {{ $t('measure.form.honey_type.amount') + ': ' + measure.amount + ' ' +$t('measure.form.units.kg') }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_honigernte' && measure.honey_type">
                  {{ $t('measure.form.honey_type.label') + ': ' + measure.honey_type }}
                </div>
                <div class="text-center" v-if="measure.type === 'massnahme_raummanagement' && measure.space_management">
                  {{ $t('measure.form.space_management.label') + ': ' + $t('measure.form.space_management.options.' + measure.space_management) }}
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </div>
      <b-modal :id="'offLineModalMeasureUpdate'" centered hide-header-close @ok="hideModal" class="network-modal">
        <template slot="modal-title">
          {{ $t('offLineModal.title') }}
        </template>
        {{ $t('offLineModal.text') }}
        <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
          <b-button size="lg" class="mt-3" @click="ok()">
            {{ $t('offLineModal.ok') }}
          </b-button>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MeasureList',
  props: ['id', 'apiary'],
  data () {
    return {
      showError: false,
      data: null,
      deleteClicked: null
    }
  },
  computed: {
    loaded () {
      return !!this.data
    }
  },
  methods: {
    checkNetworkUpdateMeasure (measureId) {
      if (navigator.onLine) {
        this.$router.replace('/measure/edit/' + measureId + '/' + this.id + '/' + this.apiary)
      } else {
        this.showOffLineModal()
      }
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModalMeasureUpdate')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalMeasureUpdate')
    },
    formatDate (date) {
      return moment(date).format('DD[.]MM[.]YYYY')
    },
    toggleCollapse (date) {
      this.$root.$emit('bv::toggle::collapse', 'measures-' + date)
    },
    async loadData () {
      try {
        const measures = await this.$api.measures.getAll(this.id) || []
        const measuresByDate = {}
        // sort by id
        measures.sort(function (rowA, rowB) {
          if (rowA.id < rowB.id) {
            return 1
          }
          if (rowA.id > rowB.id) {
            return -1
          }
          return 0
        })
        // sort by date
        measures.sort(function (rowA, rowB) {
          if (rowA.date < rowB.date) {
            return 1
          }
          if (rowA.date > rowB.date) {
            return -1
          }

          return 0
        }).forEach(function (row) {
          measuresByDate[row.date] = measuresByDate[row.date] || []
          measuresByDate[row.date].push(row)
        })

        this.data = measuresByDate
        // this.data = measures
        // console.log(this.data)
      } catch (e) { // network error etc.
        this.data = null
      }

      this.showError = !this.data
      return this.data
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  .measure-container:nth-child(2n) {
    .measure-date {
      background-color: $primary;
    }
  }

  .measure-container:nth-child(2n + 1) {
    .measure-date {
      background-color: $primary-dark;
    }
  }

  .measure-container {
    font-family: $font-family-sans-serif;

    h3 {
      font-size: 22px;
      font-weight: bold;
    }
    //.text-body {
    //  font-size: 1.25rem;
    //}
    .mb-3 {
      border-bottom: 1px $secondary solid;
    }
    //.card-body {
    //  padding: 1.25rem;
    //}
  }
  .network-modal {
    font-family: $font-family-sans-serif;
  }
  .card {
    border: 1px solid;
    font-family: $font-family-sans-serif;
  }
  .card-header {
    font-weight: bold;
    padding: 0.25rem 1.25rem;
  }
  .card-body{
    padding: 1rem 0.25rem;
  }
  .card-body h3 {
    font-size: 1.5rem;
  }
  .edit-button {
    right: 0.5rem;
    font-size: 1.25rem;
  }
</style>
